import React from "react";
import { useTranslation } from "react-i18next";
import { Student } from "@/types/Student";
import { useFetchStudents } from "@/hooks/useFetchStudents";
import { FilterContext } from "@/types/FilterContext";
import { StudentOrdering } from "@/types/StudentOrdering";
import {
  StudentListBulkMessagesSortableFieldEnum,
  SortDirectionEnum,
  YesNoEnum,
} from "@/__generated__/types";
import { useBuildUrlState } from "@/hooks/useUrlSerializer";
import { StudentCarousel } from "@/components/StudentCarousel";
import { FilterState } from "@/components/FilterSidebar/FilterState";

export const RecentlyContactedCarousel = () => {
  const { t } = useTranslation();
  const ordering = new StudentOrdering(
    StudentListBulkMessagesSortableFieldEnum.BulkMessagesRecentlyContacted,
    SortDirectionEnum.Desc,
    "bulkMessages",
  );

  const context = new FilterContext("bulkMessages");

  const { items: students, loading: recentlyContactedLoading } =
    useFetchStudents({
      paginationVariables: {
        first: 10,
      },
      ordering,
      context,
      filterState: new FilterState({ hasProfilePhoto: YesNoEnum.Yes }),
    });

  const orderingQuery = useBuildUrlState("STUDENT_ORDERING")(ordering);
  const fc = useBuildUrlState("FILTER_CONTEXT")(context);

  return (
    <StudentCarousel
      title={t("bulkMessaging.recentlyContacted")}
      students={students as Student[]}
      isLoading={recentlyContactedLoading}
      showLocation={true}
      viewAllLink={"students"}
      viewAllQuery={{ ...orderingQuery, ...fc }}
    />
  );
};
